import { CheckboxProps, FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

import { ControlledFormField } from 'common/interfaces'

export const Checkbox: ControlledFormField<CheckboxProps, { label: string }> = props => {
  const { name, control, label, disabled, sx } = props
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          sx={sx}
          checked={field.value}
          label={label}
          disabled={disabled}
          control={<MuiCheckbox {...field} name={name} color="primary" />}
        />
      )}
    />
  )
}
